import React from "react";
import CalendarView from "../../components/calendar/CalendarView";

export default function CalendarPage() {
  return <CalendarView />;
}
